<template>
  <div class="gmf-test-widget-test-container">
    <div class="gmf-mt-4 gmf-mb-4">
      This is an example widget to showcase how colors are used! Change your widget settings and see what happens here.
    </div>
    <div class="gmf-test-widget-brand-text">
      Brand colored text
    </div>
    <div class="gmf-mb-4 gmf-mt-4">
      <div class="gmf-test-widget-brand-logo">Brand colored background</div>
    </div>
    <HorizontalPills
      :items="menuItems"
      v-model:selectedItem="selectedMenuItem"
      :showSocialButton="false"
    >
    </HorizontalPills>
    <VerticalSeparator class="gmf-mt-4 gmf-mb-2">Buttons & Links</VerticalSeparator>
    <div class="gmf-test-widget-links my-4">
      <a class="gmf-link">Link</a>
      <a class="gmf-link gmf-text-small">Small link</a>
    </div>
    
    <div class="gmf-mt-2" style="display: flex; gap: var(--gmf-p-3); flex-wrap: wrap; align-items: center;">
      <button class="gmf-btn gmf-btn-primary">Button</button>
      <button class="gmf-btn-secondary gmf-btn">Button secondary</button>
      <button class="gmf-btn-sm gmf-btn-primary gmf-btn">Button small</button>
    </div>
    <VerticalSeparator class="gmf-mt-4 gmf-mb-2">Review</VerticalSeparator>
    <Comment :comment="testComment" />
    <div class="mt-4">
      <DropdownSelect
        :multiple="true"
        placeholder="Multi selection"
        v-model="multiSelect"
        :options="[
        {
          value: 1,
          label: 'Item 1',
        },
        {
          value: 2,
          label: 'Item 2',
        }]"
      />
    </div>
  </div>
</template>

<style scoped>
.gmf-test-widget-brand-logo {
  background-color: var(--gmf-brand-color);
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
  color: var(--gmf-col-white);
}

.gmf-test-widget-brand-text {
  color: var(--gmf-brand-color);
  font-weight: bold;
}

.gmf-test-widget-links {
  display: flex;
  gap: var(--gmf-p-4);
  align-items: flex-end;
}
</style>

<script>
import state from '@/state';
import Comment from '@/components/Comment';
import VerticalSeparator from '@/components/VerticalSeparator.vue';
import HorizontalPills from '@/components/HorizontalPills.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';

export default {
  components: {
    Comment,
    DropdownSelect,
    HorizontalPills,
    VerticalSeparator,
  },
  data() {
    return {
      menuItems: [
        {
          value: 'item1',
          name: 'Menu Item 1',
        },
        {
          value: 'item2',
          name: 'Menu Item 2',
        },
        {
          value: 'item3',
          name: 'Menu Item 3',
        },
      ],
      multiSelect: {},
      selectedMenuItem: { value: 'item1' },
      testComment: {
        "replyCount": 0,
        "replies": [],
        "isReply": false,
        "author": {
            "id": "test_user",
            "merchantId": state.merchantId,
            "firstName": "Test User",
            "lastName": "",
            "isGuest": false,
            "avatarCode": null,
            "avatarUrl": "https://cdn.gamifiera.com/v2/avatar/headshot/" + state.merchantId + "/test_user",
            "level": 1,
            "levelName": "Expert Reviewer",
            "publicProfile": true,
            "isOnline": false,
            "lastOnline": 0,
            "flags": [],
            "attributesJson": "{}",
            "profileSkin": {
                "uuid": "2ff24c15-3c02-4c5b-9a0a-3622adb22ca2",
                "image_url": "https://cdn.gamifiera.com/static/global/skins/85c016d7-23bb-4ca1-97c9-45c47223cad5.webp",
                "opacity": 0.30000001192092896,
                "dark": false
            }
        },
        "merchant": {
            "id": state.merchantId
        },
        "type": {
            "name": "product_review"
        },
        "target": {
            "id": "review_test_product",
            "merchantId": state.merchantId,
            "imageUrl": "https://bonti.se/bilder/artiklar/2024083.jpg?m=1648731264",
            "name": "AquaGlow Hydration Flask",
            "type": "product",
            "url": "https://bonti.se/bugaboo-dual-comfort-dyna-midnight-black"
        },
        "content": {
            "title": "Stylish and practical hydration flask",
            "text": "Love my AquaGlow Hydration Flask! The UV-C light keeps my water clean and fresh. The design is sleek and stylish, perfect for daily use.",
            "pros": [],
            "cons": [],
            "isEdited": false,
            "images": [],
            "ratings": {
                "product_score": {
                    "min": 1,
                    "max": 5,
                    "value": 5
                }
            }
        },
        "language": null,
        "pins": [],
        "polls": {},
        "isVerified": true,
        "createdAt": "2022-06-12T08:00:10.000Z",
        "votes": {
            "score": 15,
            "upvotes": 15,
            "observerVote": 1,
            "downvotes": 0
        },
        "meta": {},
        "id": "1234"
      } 
    };
  },
};
</script>
